import styled from 'styled-components';
import { ButtonWithResettedStyles } from '../../events/DetailsTab/DetailsTab.styles';
import { ArrowLeft } from '../SvgIcons';

export const Button = styled(ButtonWithResettedStyles)`
  display: flex;
  font-size: 12px;
  font-weight: 400;
  border-radius: 4px;
  width: fit-content;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px 5px 10px;
  color: ${({ theme, color }) => color ?? theme.darkgrey};
  border: 2px solid ${({ theme, color }) => color ?? theme.blue};

  position: relative;
  overflow: hidden;

  &:after {
    content: '';
    position: absolute;
    background: ${({ theme, color }) => color ?? theme.blue};
    width: 200%;
    height: 200%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
    border-radius: 50%;
    transition: transform 0.5s ease, opacity 0.5s ease;
    pointer-events: none;
  }

  &:hover:after {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.1;
  }
`;

export const StyledArrowLeft = styled(ArrowLeft)`
  margin-right: 4px;
  width: 12px !important;
  height: 12px !important;
`;
